// import List, { Header } from '../components/PlayerList';
import { connect } from 'react-redux';
import { setMasquaradeUsers, setMasquaradeUser } from '../../modules/system/masquarade';
import { getMasquaradeUsers, masquaradeUser, revertMasquarade } from '../../modules/system/masquarade_api';
import MasquaradeDropdown from '../../components/components/masquarade-dropdown/masquarade-dropdown';
import Constants from '../../constants/constants';
import AuthService from '../../services/auth/authService';
import styled from 'styled-components';

const Container = styled.section`
  padding: 0 max(6.42%, 224px);
`;
const Title = styled.h1`
  padding: 1rem 0;
`;
const MasqueradePage = ({ masquaradeUsers, masquaradeUserCount, user, isMasquaraded, dispatch }) => {
  const onSearchChange = (search_terms) => {
    if (search_terms.length < 3) {
      dispatch(setMasquaradeUsers([], 0));
      return;
    }
    getMasquaradeUsers(search_terms).then((result) => {
      const masquaradeUsers = result.data.users;
      const masquaradeUserCount = result.data.userCount;
      dispatch(setMasquaradeUsers(masquaradeUsers, masquaradeUserCount));
    });
  };
  const onSelectUser = (user_id) => {
    masquaradeUser(user_id).then((result) => {
      if (result.data && result.data.token) {
        const tokens = {
          new_auth: result.data.token,
        };

        dispatch(setMasquaradeUser(result.data.is_impersonated));

        AuthService.storeTokens(tokens);
        window.location = '/';
      }
    });
  };
  const onRevertMasquarade = () => {
    revertMasquarade().then((result) => {
      if (result.data && result.data.token) {
        const tokens = {
          new_auth: result.data.token,
        };
        AuthService.storeTokens(tokens);
        window.location = '/';
      }
    });
  };
  return (
    <Container>
      <Title>Masquerade</Title>
      <MasquaradeDropdown
        masquaradeUsers={masquaradeUsers}
        masquaradeUserCount={masquaradeUserCount}
        displayUserRole={Constants.ADMIN_ROLE_LEVEL}
        currentUserRole={user.roleLevel}
        isMasquaraded={isMasquaraded}
        onSearchChange={(value) => onSearchChange(value)}
        onSelectUser={(id) => onSelectUser(id)}
        onRevertMasquarade={() => onRevertMasquarade()}
      ></MasquaradeDropdown>
    </Container>
  );
};

const withState = connect((state) => {
  const { role, user, masquarade } = state;

  return {
    roles: role.roles,
    user: user,
    masquaradeUsers: masquarade.masquaradeUsers,
    masquaradeUserCount: masquarade.masquaradeUserCount,
    isMasquaraded: user ? user.isMasquaraded : null,
  };
});
export default withState(MasqueradePage);
